import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Defeitos() {
    const [defeitos, setDefeitos] = useState([]);
    const [index, setIndex] = useState(null);
    const [nome, setNome] = useState('');

    const [display, setDisplay] = useState(false);
    const [loading, setLoading] = useState();
    const [mode, setMode] = useState(null);
    const [selected, setSelected] = useState(null);

    const toast = useRef(null);

    const handleSubmit = () => {
        if (nome === '')
            return;
        setLoading(true);
        api.post('cadastros/defeitos/store', {
            "nome": nome
        }).then((response) => {
            let copy = [...defeitos];
            copy.push(response.data.defeito);
            setDefeitos(copy);

            hideDialog();
            setLoading(false);
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleUpdate = () => {
        if(nome === '') {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir.'
            });
            return;
        }
        setLoading(true);
        api.post('cadastros/defeitos/update', {
            "defeito_id": selected,
            "nome" : nome
        }).then((response) => {
            let copy = [...defeitos];
            copy[index].nome = nome;
            setDefeitos(copy); 

            setLoading(false);
            hideDialog();
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setNome('');
            setLoading(false);
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleDelete = (rowData, rowIndex) => {
        confirmDialog({
            header: 'Confirmação',
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            message: 'Você tem certeza que deseja excluir esse registro?',
            accept: () => {
                setLoading(true);
                api.post('cadastros/defeitos/delete', {
                    'defeito_id': rowData.id
                }).then((response) => {
                    let copy = [...defeitos];
                    copy.splice(rowIndex, 1);
                    setDefeitos(copy);

                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: response.data.message
                    });
                }).catch((error) => {
                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: error.response.data.message
                    });
                });
            }
        });
    }

    const openDialog = (rowData, type = null) => {
        if(type === "edit") {
            setNome(rowData.nome);
            setSelected(rowData.id)
        }
        setDisplay(true);
    }

    const hideDialog = () => {
        setDisplay(false);
        setIndex(null);
        setSelected(null);
        setNome('');
    }

    useEffect(() => {
        setLoading(true);
        api.get('cadastros/defeitos').then((response) => {
            setDefeitos(response.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog onHide={hideDialog} breakpoints={{ '960px': '90vw' }} style={{ minWidth: '30vw' }} visible={display} header={mode === "edit" ? "Editar" : "Cadastrar"} footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog} />
                    <Button className="p-button-success" label="Salvar" loading={loading} onClick={mode === "edit" ? handleUpdate : handleSubmit} />
                </div>
            )}>
                <div className="p-fluid">
                    <div className="p-field">
                        <InputText
                            onChange={e => setNome(e.target.value)}
                            placeholder="Digite o nome do defeito"
                            type="text"
                            value={nome}
                        />
                    </div>
                </div>
            </Dialog>

            <Card header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start" style={{ width: '100%' }}>
                    <h1 className="p-m-3">Defeitos</h1>
                    <Button className="p-button-primary p-mr-3 p-mt-3" icon="pi pi-plus" onClick={() => setDisplay(true)} />
                </div>
            )} className="p-m-3">
                <DataTable value={defeitos} >
                    <Column header="ID" field="id" style={{ width: '25%' }} />
                    <Column header="Nome do Defeito" field="nome" style={{ width: '50%' }} />
                    <Column header="Ações" style={{ width: '25%' }}  body={(rowData, index) => (
                        <div>
                            <Button className="p-button-primary p-mr-1" icon="pi pi-pencil" onClick={() => {
                                setIndex(index.rowIndex);
                                setMode('edit');
                                openDialog(rowData, 'edit');
                            }} />
                            <Button className="p-button-danger p-ml-1" icon="pi pi-trash" onClick={() => handleDelete(rowData, index.rowIndex)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}